import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from '../../utils/useTranslation';
import { Button } from '../input/Button';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { Stack } from '../layout/Stack';
import { Typography } from '../typography/Typography';
import { CollectionCardSkeleton } from './CollectionCard';
import type { CollectionUI } from './types';

const GridRoot = styled(Stack).attrs({
    spacing: 1,
    direction: 'row',
    flexWrap: 'wrap',
    p: { xs: 1, md: 0 },
})``;

interface CollectionsGridProps {
    isLoading: boolean;
    collections: CollectionUI[];
    renderItem: (index: number) => ReactElement;
}

export function CollectionsGrid(props: CollectionsGridProps) {
    const { isLoading, collections, renderItem } = props;
    const t = useTranslation();

    if (isLoading) {
        return (
            <GridRoot count={6} renderItem={(index) => <CollectionCardSkeleton key={index} />} />
        );
    }

    if (collections.length === 0) {
        return (
            <Flex
                px={4}
                py={6}
                overflow="hidden"
                direction="column"
                alignItems="center"
                justifyContent="center"
                borderRadius={{ sm: 3 }}
                background="var(--background-primary)"
            >
                <Typography as="h3" variant="title3" weight="bold" mb={1} textAlign="center">
                    {t('В избранном ничего нет')}
                </Typography>
                <Typography variant="body" color="secondary" textAlign="center">
                    {t('В этом разделе будут находиться посты, которые вы добавите из ленты')}
                </Typography>
                <Box pt={3}>
                    <Button as={Link} to="/" size="m" variant="outlined">
                        {t('Перейти в ленту')}
                    </Button>
                </Box>
            </Flex>
        );
    }

    return <GridRoot count={collections.length} renderItem={renderItem} />;
}
